import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/InventoryConversionReport/InventoryConversionReportAction'


//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseReportInventortConversionActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/InventoryConversionReport/InventoryConversionReport")
	}

	render() {
		return (
			<Activity 
				name="InventoryConversionReport"
				RenderedComponent={this.RenderedComponent}
				context="InventoryConversionReport"
				action="InventoryConversionReport"
				formActions={FormAction}
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseReportInventortConversionActivity)
